import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP } from '../../node_modules/@ionic-native/http/ngx';
import { HttpClient, HttpClientModule } from '../../node_modules/@angular/common/http';
// import { FormBuilder } from '../../node_modules/@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { GoogleAnalytics } from '../../node_modules/@ionic-native/google-analytics/ngx';
// import { DatePickerModule } from '../../node_modules/ionic4-date-picker';

// import { Calendar } from '@ionic-native/calendar/ngx';

const routes: Routes = [

];
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [RouterModule.forRoot(routes, { useHash: true }),BrowserModule, HttpClientModule, IonicModule.forRoot(), AppRoutingModule, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })],
  providers: [
    StatusBar,
    SplashScreen,
    HTTP,
    HttpClient,
    // FormBuilder,
    GoogleAnalytics,
 
    // DatePickerModule,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
